import { rootApi } from '../rootApi';

/**
 * LMS Eğitim Kataloğu — `/v1.0/LmsTrainingCatalog`.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 1.md §3.
 *
 * `trainingName` ve `trainingCode` backend tarafından otomatik üretilir; istekte gönderilmez.
 * `instructorsCount` salt okunurdur, backend her istekte yeniden hesaplar. Eğitmen atama/silme
 * işlemleri bu tag'i de invalidate eder ki katalog listesi/detayı güncel eğitmen sayısını göstersin.
 */
export const lmsTrainingCatalogApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTrainingCatalogs: builder.query({
            query: ({ trainingCode, trainingName, vehicleModel, trainingType, trainingLocation, status, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsTrainingCatalog/GetList',
                method: 'POST',
                body: {
                    trainingCode: trainingCode || null,
                    trainingName: trainingName || null,
                    vehicleModel: vehicleModel || null,
                    trainingType: trainingType || null,
                    trainingLocation: trainingLocation || null,
                    status: status ?? null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTrainingCatalog']
        }),

        getLmsTrainingCatalogDropdown: builder.query({
            query: (trainingCode) => ({
                url: 'v1/LmsTrainingCatalog/GetDropdown',
                method: 'GET',
                params: trainingCode ? { TrainingCode: trainingCode } : {}
            }),
            transformResponse: (response) => (Array.isArray(response?.data) ? response.data : []),
            providesTags: ['LmsTrainingCatalog']
        }),

        getLmsTrainingCatalogById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingCatalog/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingCatalog']
        }),

        // Planlama ekranında ("Eğitim Kodu" seçilince) katalog + eğitmen + içerik/kazanım bilgilerini
        // tek istekte getirmesi beklenen "detay" ucu. Doküman henüz güncellenmedi; alan adları
        // GetById/Update ile aynı varsayılıyor (bkz. training-planning/components/PlanningForm.jsx
        // içindeki eşleme yorumu) - backend'in gerçek response şekli görülünce burası doğrulanmalı.
        getLmsTrainingCatalogDetailById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingCatalog/GetDetailById',
                method: 'GET',
                params: { Id: id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingCatalog']
        }),

        addLmsTrainingCatalog: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingCatalog/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingCatalog']
        }),

        updateLmsTrainingCatalog: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingCatalog/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingCatalog']
        }),

        deleteLmsTrainingCatalog: builder.mutation({
            query: (id) => ({
                url: `v1/LmsTrainingCatalog/${id}`,
                method: 'DELETE'
            }),
            // Silme, eğitime bağlı eğitmen atamalarını da pasife çeker (doc §3.7)
            invalidatesTags: ['LmsTrainingCatalog', 'LmsTrainingInstructor']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTrainingCatalogsQuery,
    useGetLmsTrainingCatalogDropdownQuery,
    useGetLmsTrainingCatalogByIdQuery,
    useGetLmsTrainingCatalogDetailByIdQuery,
    useAddLmsTrainingCatalogMutation,
    useUpdateLmsTrainingCatalogMutation,
    useDeleteLmsTrainingCatalogMutation
} = lmsTrainingCatalogApi;
